import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
import { RichTextSchema } from "../../fragments/RichText";
import { generateContentGroupSchema } from "../../utils/helpers";
const GroupedRichTextSchema = generateContentGroupSchema(RichTextSchema);
export const GroupedRichTextBladeTypeValues = ["articleRichTextAccordion", "landingRichTextAccordion"];
export const GroupedRichTextBladeTypesSchema = z.enum(GroupedRichTextBladeTypeValues);
export const GroupedRichTextBladeTypes = GroupedRichTextBladeTypesSchema.enum;
export const GroupedRichTextBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    groups: z.array(GroupedRichTextSchema),
});
export const GroupedRichTextBladesContractSchema = GroupedRichTextBladeSchema.extend({
    type: GroupedRichTextBladeTypesSchema,
});
export const ArticleRichTextAccordionContractSchema = GroupedRichTextBladeSchema.extend({
    type: z.literal(GroupedRichTextBladeTypes.articleRichTextAccordion),
});
export const LandingRichTextAccordionContractSchema = GroupedRichTextBladeSchema.extend({
    type: z.literal(GroupedRichTextBladeTypes.landingRichTextAccordion),
});
//# sourceMappingURL=index.js.map